import { graphql, useStaticQuery } from "gatsby";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import Modal from "./modal";
import FormSelect from "./elements/form-select";
import { GroupProvider } from "../context/group";
import { CDN_BASE_URL } from "../utility/constants";
import classNames from "classnames";

const LineModal = ({ show, onHide }) => {
  const ref = useRef(null);
  const dialogRef = useRef(null);

  const [formErrors, setFormErrors] = useState({});
  const [lineOption, setLineOption] = useState("");

  const line = useMemo(
    () => (lineOption ? parseInt(lineOption.split("_")[0]) : null),
    [lineOption]
  );

  const { labelManagerLabels, booklet } = useStaticQuery(graphql`
    {
      labelManagerLabels: labelManagerLabels {
        close
        formProductLine
        howReadProductCode
      }
      booklet: liferayBooklet {
        id
        liferayFields {
          siteId
          articleId
        }
        line {
          ... on LiferayLinesMultivalue {
            selectGroups {
              label
              group {
                label
                value
              }
            }
          }
        }
        booklet
        bookletRequest
      }
    }
  `);
  const lineOpts = useMemo(
    () =>
      [
        {
          value: "",
          label: labelManagerLabels.select,
        },
      ].concat(booklet.line.selectGroups),
    [booklet, labelManagerLabels]
  );

  const onChange = useCallback((e) => {
    if (e.target.name === "lineOption") {
      setLineOption(e.target.value);
    }
  }, []);

  const formInfo = useMemo(
    () => ({
      formData: {
        lineOption,
      },
      onChange,
      formErrors,
      setFormErrors,
    }),
    [lineOption, formErrors, onChange]
  );

  const clickBack = useCallback(
    (event) => {
      if (
        event.target !== dialogRef.current &&
        dialogRef.current &&
        !dialogRef.current.contains(event.target)
      ) {
        onHide();
      }
    },
    [onHide]
  );

  useEffect(() => {
    if (!show) {
      setLineOption("");
      setFormErrors({});
    }
    if (show && ref.current) {
      ref.current.focus();
    }
  }, [show]);

  const onKeyDown = useCallback(
    (e) => {
      if (e.key === "Escape") {
        onHide();
      }
    },
    [onHide]
  );

  return (
    <Modal>
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
      <div
        ref={ref}
        className={`cart-modal${show ? " show cart-modal--line" : ""}`}
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex={show ? 0 : -1}
        role="dialog"
        aria-hidden={!show}
        onKeyDown={onKeyDown}
        onClick={clickBack}
      >
        <div
          ref={dialogRef}
          className={classNames(
            "cart-modal__dialog",
            lineOption && "cart-modal__dialog--line-selected"
          )}
          role="document"
        >
          <div className="text-center">
            <GroupProvider data={formInfo}>
              <div className="container">
                <div className="row text-center">
                  <div className="col-12">
                    <p className="manuali__select-label">{labelManagerLabels.formProductLine}</p>
                    <FormSelect
                      id="line"
                      field="lineOption"
                      label={labelManagerLabels.formProductLine}
                      options={lineOpts}
                      className="manuali__select manuali__select--lines"
                    />
                  </div>
                </div>
              </div>
              {line && (
                <>
                  <section className="section pb-0 mt-5" data-line={line}>
                    <div className="container">
                      <div className="row text-center">
                        <div className="col-12">
                          <p>{labelManagerLabels.bookletFindImage}</p>
                          <div className="manuali__contenuto">
                            <img
                              alt={labelManagerLabels.formProductLine}
                              src={`${CDN_BASE_URL}/booklet/libretto-${line}.png`}
                            />
                            <img
                              alt={labelManagerLabels.howReadProductCode}
                              src={`${CDN_BASE_URL}/booklet/libretto-label.png`}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </>
              )}
            </GroupProvider>
            <button className="cart-modal__close mt-3 mt-md-4" onClick={onHide}>
              {labelManagerLabels.close}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default LineModal;
